// @ts-nocheck
/* eslint-disable import/no-extraneous-dependencies */

const getUnit = value => {
  if (typeof value === 'string') {
    return value;
  }
  return `${value}px`;
};
const calculateOffset = _ref => {
  let {
    moveBy,
    placement = ''
  } = _ref;
  /*
   * For `right` and `left` placements, we need to flip the `x` and `y` values as Popper.JS will use
   * the first value for the main axis. As per Popper.js docs:
   *
   *   if the placement is top or bottom, the length will be the width. In case of left or right, it
   *   will be the height.
   *
   */
  if (placement.includes('right') || placement.includes('left')) {
    return [moveBy ? moveBy.y : 0, moveBy ? moveBy.x : 0];
  }
  return [moveBy ? moveBy.x : 0, moveBy ? moveBy.y : 0];
};
const resolveWidth = _ref2 => {
  let {
    width,
    minWidth,
    dynamicWidth,
    referenceWidth
  } = _ref2;
  return {
    minWidth: dynamicWidth ? `${referenceWidth}px` : getUnit(minWidth),
    width: width || 'auto'
  };
};
export const createModifiers = _ref3 => {
  let {
    width,
    moveBy,
    appendTo,
    shouldAnimate,
    flip,
    fixed,
    placement,
    isTestEnv,
    minWidth,
    dynamicWidth
  } = _ref3;
  const preventOverflow = !fixed;
  const modifiers = [{
    name: 'offset',
    options: {
      offset: calculateOffset({
        moveBy,
        placement
      })
    }
  }, {
    name: 'computeStyles',
    enabled: !isTestEnv,
    options: {
      gpuAcceleration: !shouldAnimate
    }
  }, {
    name: 'flip',
    enabled: typeof flip !== 'undefined' ? flip : !moveBy
  }, {
    name: 'preventOverflow',
    enabled: preventOverflow,
    options: {
      boundariesElement: appendTo || undefined
    }
  }, {
    name: 'hide',
    enabled: preventOverflow
  }];
  if (dynamicWidth || minWidth || width) {
    modifiers.push({
      name: 'setPopperWidth',
      enabled: true,
      order: 840,
      fn: data => {
        const {
          width: referenceWidth
        } = data.offsets.reference;
        data.styles = {
          ...data.styles,
          ...resolveWidth({
            width,
            referenceWidth,
            minWidth,
            dynamicWidth
          })
        };
        return data;
      }
    });
  }
  return modifiers;
};
//# sourceMappingURL=modifiers.js.map